import React, { useMemo } from 'react';
import { Segment } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import type { TReportOwner } from './constants';

export interface IReportOwnerSegmentProps {
  value: TReportOwner;
  onChange: (value: TReportOwner) => void;
  className?: string;
  showAll?: boolean;
}

export default function ReportOwnerSegment({
  value,
  onChange,
  className = 'segment-font12',
  showAll = false,
}: IReportOwnerSegmentProps) {
  const { formatMessage } = useLanguage();

  const options = useMemo(() => {
    const list = [
      {
        text: formatMessage({ id: 'My Reports-1' }),
        value: 'mine' as TReportOwner,
      },
      {
        text: formatMessage({ id: 'Shared With Me' }),
        value: 'shared' as TReportOwner,
      },
    ];

    if (showAll) {
      list.unshift({
        text: formatMessage({ id: 'All Reports' }),
        value: 'all' as TReportOwner,
      });
    }

    return list;
  }, [formatMessage, showAll]);

  return (
    <Segment
      className={className}
      value={value}
      onChange={onChange}
      options={options}
    />
  );
}
